// extracted by mini-css-extract-plugin
export default {"buttonsWrapper":"ButtonsWrapper_buttonsWrapper__-0Eg6"};